module.exports = __webpack_public_path__ + "apple-touch-icon.073e69ba.png";